<template>
  <div>
    <div class="form-base__title">
      Основание получения сведений, содержащихся в Едином государственном
      реестре недвижимости
    </div>

    <div class="form-section-base__controls">
      <v-row>
        <v-col>
          <v-radio-group v-model="docType">
            <v-radio
              :label="evidenceDocTypeToDocumentTitle[DocumentType.CONTRACT]"
              :value="DocumentType.CONTRACT"
            />
            <Document
              v-if="docType === DocumentType.CONTRACT"
              :v="$v.document"
              has-description
            />

            <v-radio
              :label="
                evidenceDocTypeToDocumentTitle[
                  DocumentType.PRELIMINARY_CONTRACT
                ]
              "
              :value="DocumentType.PRELIMINARY_CONTRACT"
            />
            <Document
              v-if="docType === DocumentType.PRELIMINARY_CONTRACT"
              :v="$v.document"
              has-description
            />

            <v-radio
              :label="
                evidenceDocTypeToDocumentTitle[
                  DocumentType.PROTECTION_PRIVATIZATION
                ]
              "
              :value="DocumentType.PROTECTION_PRIVATIZATION"
            />
            <Document
              v-if="docType === DocumentType.PROTECTION_PRIVATIZATION"
              :v="$v.document"
              has-description
            />

            <v-radio
              :label="
                evidenceDocTypeToDocumentTitle[DocumentType.COMPENSATION_DAMAGE]
              "
              :value="DocumentType.COMPENSATION_DAMAGE"
            />
            <Document
              v-if="docType === DocumentType.COMPENSATION_DAMAGE"
              :v="$v.document"
              has-description
            />

            <v-radio
              :label="
                evidenceDocTypeToDocumentTitle[DocumentType.LAWSUIT_RIGHTHOLDER]
              "
              :value="DocumentType.LAWSUIT_RIGHTHOLDER"
            />
            <Document
              v-if="docType === DocumentType.LAWSUIT_RIGHTHOLDER"
              :v="$v.document"
              has-description
            />

            <v-radio
              :label="
                evidenceDocTypeToDocumentTitle[
                  DocumentType.FORECLOSURE_ESTATE_RIGHTHOLDER
                ]
              "
              :value="DocumentType.FORECLOSURE_ESTATE_RIGHTHOLDER"
            />
            <Document
              v-if="docType === DocumentType.FORECLOSURE_ESTATE_RIGHTHOLDER"
              :v="$v.document"
              has-description
            />

            <v-radio
              :label="
                evidenceDocTypeToDocumentTitle[DocumentType.OTHER_RIGHTHOLDER]
              "
              :value="DocumentType.OTHER_RIGHTHOLDER"
            />
            <Document
              v-if="docType === DocumentType.OTHER_RIGHTHOLDER"
              :v="$v.document"
              has-description
            />
          </v-radio-group>
        </v-col>
      </v-row>
    </div>

    <Footer
      @next-btn-click="btnSaveClickHandler(StepDirection.NEXT)"
      @prev-btn-click="btnSaveClickHandler(StepDirection.PREV)"
      :loading-next="loadingNext"
    />
  </div>
</template>

<script>
import cloneDeep from 'clone-deep';
import { checkInvalid, leaveStep } from '@/utils/services';
import { Role } from '@/utils/dictionaries';
import { ServicesModule } from '@/store/modules/services';
import { DocumentType, StepDirection, StepName } from '@/types/services';
import { maxLength, required } from 'vuelidate/lib/validators';
import { getValidationErrorText } from '@/utils/validate';
import Footer from '@/components/services/elements/Footer';
import Document from './Document';
import {
  EgrnConfirmStep,
  evidenceDocTypeToDocumentName,
  evidenceDocTypeToDocumentTitle,
} from '@/constants';

export default {
  name: 'DocsForm',
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Footer,
    Document,
  },
  data: () => ({
    DocumentType,
    evidenceDocTypeToDocumentTitle,
    getValidationErrorText,
    StepDirection,
    StepName,
    leaveStep,
    Role,
    invalidFields: [],
    docType: DocumentType.CONTRACT,
    document: {
      description: '',
      file: null,
      fileSig: null,
    },
  }),
  computed: {
    storeDocType() {
      return ServicesModule.statement.evidenceDocType;
    },

    storeDocName() {
      return this.storeDocType
        ? evidenceDocTypeToDocumentName[this.storeDocType]
        : null;
    },
  },
  validations() {
    return {
      document: {
        description: {
          maxLength: maxLength(4000),
        },
        file: {
          required,
        },
        fileSig: {
          required,
        },
      },
    };
  },
  created() {
    this.prefillDraft();
  },
  methods: {
    prefillDraft() {
      if (!this.storeDocName) return;

      this.docType = this.storeDocType;
      this.document = cloneDeep(ServicesModule.statement[this.storeDocName]);
    },

    touchFields() {
      this.invalidFields = [];
      this.$v.$touch();
      checkInvalid(this.$v, this.invalidFields);
    },

    assemblyModel() {
      return {
        docType: this.docType,
        document: this.document,
      };
    },

    btnSaveClickHandler(direction) {
      leaveStep({
        stepThis: this,
        direction,
        step: EgrnConfirmStep.PROOF,
      });
    },
  },
};
</script>
